import React from "react";
import { Grid } from "@mui/material";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import Stack from "@mui/material/Stack";
import { UiButton } from "../../../../../../_uiComponents/common/form/UiButton";
import { UiRadioButton } from "../../../../../../_uiComponents/telerikComponents/UiRadioButton";
import UiInput from "../../../../../../_uiComponents/telerikComponents/UiInput";

export default function GamePlayConfigurationForm(props) {
     const { gamePlayTokenCount } = props;
     const radioButtonValidator = (value) =>
          value ? "" : "Please select an option.";
     const totalRewardSlotsValidator = (value) =>
          value ? "" : "Total Reward Slots is required.";
     const totalUnluckySlotsValidator = (value) =>
          value ? "" : "Total Unlucky Slots is required.";
     const radioValidator = (value) =>
          value ? "" : "Game play option is required.";
     const inputValidator = (value) =>
          value ? "" : "Unlucky game play count is required.";

     // Convert gamePlayTokenCount to string for comparison with radio values
     const initialSelectedOption = gamePlayTokenCount
          ? gamePlayTokenCount.toString()
          : null;
     console.log("Initial Selected Option:", initialSelectedOption);

     const handleSubmit = (dataItem) => {
          console.log("Submitted value:", dataItem.selectedOption);
          // Process the submitted value
          props.onSubmit && props.onSubmit(dataItem.selectedOption);
     };

     const handleCheckBoxChange = (e) => {
          // Handle radio button change if needed
     };

     return (
          <>
               <Form
                    onSubmit={handleSubmit}
                    initialValues={{ selectedOption: initialSelectedOption }}
                    render={(formRenderProps) => (
                         <FormElement>
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                   <Grid item xs={12}>
                                        <div style={{ marginBottom: "16px" }}>
                                             <label className="k-form-label k-section-top-label">
                                                  Required Token Count
                                             </label>
                                             <Stack spacing={2} direction="row">
                                                  <Field
                                                       name="selectedOption"
                                                       component={UiRadioButton}
                                                       labelClassName={"ssss"}
                                                       value="1"
                                                       checked={
                                                            initialSelectedOption ==
                                                            1
                                                       }
                                                       validator={
                                                            radioButtonValidator
                                                       }
                                                  />
                                                  <span className="sb-game-play-wrapper__span">
                                                       One
                                                  </span>
                                                  <Field
                                                       name="selectedOption"
                                                       component={UiRadioButton}
                                                       value="2"
                                                       checked={
                                                            initialSelectedOption ==
                                                            2
                                                       }
                                                  />
                                                  <span className="sb-game-play-wrapper__span">
                                                       Two
                                                  </span>
                                                  <Field
                                                       name="selectedOption"
                                                       component={UiRadioButton}
                                                       value="3"
                                                       checked={
                                                            initialSelectedOption ==
                                                            3
                                                       }
                                                  />
                                                  <span className="sb-game-play-wrapper__span">
                                                       Three
                                                  </span>
                                             </Stack>
                                        </div>
                                   </Grid>
                              </Grid>
                              <Grid container spacing={2} sx={{ mb: 3 }}>
                                   <Grid item xs={12} lg={6}>
                                        <Field
                                             name={"totalRewardSlots"}
                                             validator={
                                                  totalRewardSlotsValidator
                                             }
                                             component={UiInput}
                                             labelClassName={"k-form-label"}
                                             label={"Total Reward Slots"}
                                        />
                                   </Grid>
                                   <Grid item xs={12} lg={6}>
                                        <Field
                                             name={"totalUnluckySlots"}
                                             validator={
                                                  totalUnluckySlotsValidator
                                             }
                                             component={UiInput}
                                             labelClassName={"k-form-label"}
                                             label={"Total Unlucky Slots"}
                                        />
                                   </Grid>
                              </Grid>
                              <label className="k-form-label k-section-top-label">
                                   Gameplay Winning Mode
                              </label>

                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                   <Grid item xs={12} lg={6}>
                                        <div className="sb-game-play-wrapper">
                                             <Field
                                                  name={"gamePlay"}
                                                  validator={radioValidator}
                                                  component={UiRadioButton}
                                                  handleChange={
                                                       handleCheckBoxChange
                                                  }
                                                  value={"1"}
                                                  labelClassName={
                                                       "k-form-label"
                                                  }
                                             />
                                             <span className="sb-game-play-wrapper__span">
                                                  {" "}
                                                  Continuous Wining Game Play{" "}
                                             </span>
                                        </div>
                                   </Grid>
                              </Grid>
                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                   <Grid item xs={12} lg={12}>
                                        <div className="sb-game-play-wrapper">
                                             <Field
                                                  name={"gamePlay"}
                                                  validator={radioValidator}
                                                  component={UiRadioButton}
                                                  handleChange={
                                                       handleCheckBoxChange
                                                  }
                                                  value={"2"}
                                                  labelClassName={
                                                       "k-form-label"
                                                  }
                                             />
                                             <span className="sb-game-play-wrapper__span">
                                                  {" "}
                                                  Win After Every{" "}
                                             </span>
                                             <Field
                                                  name={"gamePlayInput"}
                                                  // validator={formRenderProps.valueGetter('gamePlay') === '2' ? inputValidator : null}
                                                  component={UiInput}
                                                  labelClassName={
                                                       "k-form-label"
                                                  }
                                                  // disabled={formRenderProps.valueGetter('gamePlay') !== '2'}
                                             />
                                             <span className="sb-game-play-wrapper__span">
                                                  Unlucky Game Play
                                             </span>
                                        </div>
                                   </Grid>
                              </Grid>

                              <Grid container spacing={2} sx={{ mb: 1 }}>
                                   <Grid item xs={12} lg={6}>
                                        <div className="sb-game-play-wrapper">
                                             <Field
                                                  name={"gamePlay"}
                                                  validator={radioValidator}
                                                  component={UiRadioButton}
                                                  handleChange={
                                                       handleCheckBoxChange
                                                  }
                                                  value={"3"}
                                                  labelClassName={
                                                       "k-form-label"
                                                  }
                                             />
                                             <span className="sb-game-play-wrapper__span">
                                                  {" "}
                                                  Random{" "}
                                             </span>
                                        </div>
                                   </Grid>
                              </Grid>
                              <Grid>
                                   <Grid item xs={12} sx={{ mb: 2 }}>
                                        <Stack
                                             spacing={2}
                                             direction="row"
                                             justifyContent="end"
                                             sx={{ width: "100%" }}
                                        >
                                             <UiButton
                                                  name="Cancel"
                                                  variant="outlined"
                                                  size="small"
                                                  onClick={
                                                       formRenderProps.onFormReset
                                                  }
                                             />
                                             <UiButton
                                                  name="Save"
                                                  variant="contained"
                                                  size="small"
                                                  onClick={
                                                       formRenderProps.onSubmit
                                                  }
                                                  disabled={
                                                       !formRenderProps.allowSubmit
                                                  }
                                             />
                                        </Stack>
                                   </Grid>
                              </Grid>
                         </FormElement>
                    )}
               />
          </>
     );
}
